import * as actionTypes from './actionTypes';
import { getWorkerDetail } from '../api';

export function clearWorkerQuickView () {
  return dispatch => dispatch({ type: actionTypes.CLEAR_WORKER_QUICK_VIEW });
}

export function getWorkerQuickView (id) {
  return dispatch => {
    dispatch({ type: actionTypes.GET_WORKER_QUICK_VIEW_START });

    return getWorkerDetail(id)
      .then(({ data }) => dispatch({ type: actionTypes.GET_WORKER_QUICK_VIEW_SUCCESS, data: { id, ...data } }))
      .catch(error => dispatch({ type: actionTypes.GET_WORKER_QUICK_VIEW_ERROR, error }));
  };
}



// WEBPACK FOOTER //
// ./src/actions/worker.js